import React from 'react';
const SvgOdp = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M44 38H4V10h32l8 8v1z" />
      <path fill="#D14C32" d="M30 24h8.975A9.485 9.485 0 0030 15.025V24z" />
      <path
        fill="#C8C8C8"
        d="M30 25h-1v-9.975c-5.013.262-9 4.397-9 9.475a9.5 9.5 0 009.5 9.5c5.078 0 9.213-3.987 9.475-9H30zM7 18h10v1H7zM7 15h10v1H7zM7 21h10v1H7zM7 24h10v1H7zM7 27h10v1H7zM7 30h10v1H7zM7 33h10v1H7z"
      />
      <path fill="#949494" d="M36 9H3v30h42V18l-9-9zm0 1.542L43.5 18H36v-7.458zM44 38H4V10h31v9h9v19z" />
      <path fill="#FFF" d="M36 10.542L43.5 18H36z" />
      <linearGradient id="odp_svg__a" gradientUnits="userSpaceOnUse" x1={5.721} y1={6.716} x2={37.847} y2={45.002}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odp_svg__a)" d="M45 18l-9-9H3v30h42V18z" />
      <linearGradient id="odp_svg__b" gradientUnits="userSpaceOnUse" x1={34.068} y1={18.432} x2={39.735} y2={12.765}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#odp_svg__b)" d="M12 9v1h23v9h9v20h1V18l-9-9z" />
      <linearGradient id="odp_svg__c" gradientUnits="userSpaceOnUse" x1={39.5} y1={21.906} x2={39.5} y2={19.087}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odp_svg__c)" d="M35 19h9v3h-9z" />
    </svg>
  );
});
export default SvgOdp;
SvgOdp.iconName = 'odp';
SvgOdp.displayName = 'SvgOdp';
